module.exports = __webpack_public_path__ + "img/icon-top-arrow.2eca9b43.svg";